export default "__VITE_ASSET__CQij1WTh__"